import { render, staticRenderFns } from "./contact-us-messages.vue?vue&type=template&id=1689076c&"
import script from "./contact-us-messages.vue?vue&type=script&lang=js&"
export * from "./contact-us-messages.vue?vue&type=script&lang=js&"
import style0 from "./contact-us-messages.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports